/** Moyens de paiement acceptés en tontine ivoirienne, avec leur couleur de marque. */
export const PAYMENT_MODES = {
  wave: { label: 'Wave', color: 'var(--color-pay-wave)' },
  orange: { label: 'Orange Money', color: 'var(--color-pay-orange)' },
  mtn: { label: 'MTN MoMo', color: 'var(--color-pay-mtn)' },
  moov: { label: 'Moov Money', color: 'var(--color-pay-moov)' },
  especes: { label: 'Espèces', color: 'var(--color-pay-especes)' },
} as const;

export type PaymentMode = keyof typeof PAYMENT_MODES;

export const PAYMENT_MODE_KEYS = Object.keys(PAYMENT_MODES) as PaymentMode[];

/** Valeurs attendues par `POST /api/tontines/[id]/contributions`. */
export const PAYMENT_METHOD_OF: Record<PaymentMode, string> = {
  wave: 'WAVE',
  orange: 'ORANGE_MONEY',
  mtn: 'MTN_MOMO',
  moov: 'MOOV_MONEY',
  especes: 'CASH',
};
